// extracted by mini-css-extract-plugin
module.exports = {"wfao701":"wfao701"};